import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

export function setProfile(profile) {
    return { type: "SET_PROFILE", profile};
}

export function getProfile() {
    return dispatch => {
        let lr_id = Common.getUserData("id", true);
        let username = Common.getUserData('primaryEmail', true);
        let domain_url = Config.domainUrl;



        fetch(Config.domainUrl +"user/change-profile", {
            method: "POST",
           headers: {
               'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
              },
            body: JSON.stringify({
                    learner_id:lr_id,
                    username : username,
                    domain : domain_url

                  })
           }).then((response) => response.json())
               .then((responseJson) => {
                    // Common.reactLoader("hide");
                   
                    dispatch(setProfile(responseJson));
                   

                }).catch(error => {
                    console.error(error);
                    
                });    
     
    };
}


// WEBPACK FOOTER //
// ./src/actions/profileAction.js